import React, { useState, useEffect } from 'react';
import { Avatar, Box, Container, Paper, Grow, Grid, Typography, Tabs, Tab, Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { AUTH_ACTION } from '../../../interface';
import { signin, signup } from '../../../actions/auth';
import useStyles from './styles';
import Input from '../Input/Input';
import InfoSetup from './InfoSetup/InfoSetup';
import PasswordSetup from './PasswordSetup/PasswordSetup';
import useCommonStyles from '../../CommonStyle/commonStyle';
import IconSetup from './IconSetup/IconSetup';
import GoToTop from '../../Functional/GoToTop';
import PopupNotice from '../../PopupNotice/PopupNotice';
import { store } from '../../../index';

type RootState = ReturnType<typeof store.getState>;

const initialState = { firstName: '', lastName: '', spellFirstName: '', spellLastName: '', email: '', userID: '', profilePic: '', password: '', confirmPassword: '', userType: 'student' };

const Signup = () => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const [form, setForm] = useState(initialState);
    const [signupStep, setSignupStep] = useState(0);
    const [next, setNext] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [isSignup, setIsSignup] = useState(false);
    const [open, setOpen] = useState(false);

    const { isLoading, errors } = useSelector((state: RootState) => state.auth);

    const handleShowPassword = () => setShowPassword((prevShowPassword) => (!prevShowPassword));

    const handleShowRepeatPassword = () => setShowRepeatPassword((prevShowRepeatPassword) => (!prevShowRepeatPassword));
    const [message, setMessage] = useState("アカウントが承認されるまでお待ち下さい。");

    useEffect(() => {
        if(errors!=null){
            setMessage(errors);
            setOpen(true);
        }else if(!isLoading&&signupStep==2){
            setMessage("アカウントが承認されるまでお待ち下さい。");
            setOpen(true);
        }
    }, [isLoading, errors]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        console.log(e);
        const formName = (e.target as HTMLFormElement).name;

        if (formName === 'profileImageForm') {
            if (next) {
                setSignupStep(signupStep + 1)
            } else {
                setSignupStep(signupStep - 1)
            }
        } else if (formName === 'profileInfoForm') {
            if (next) {
                setSignupStep(signupStep + 1)
            }
        } else if (formName === 'passwordForm') {
            // setForm({ ...form, userType: "student" })
            dispatch(signup(form, history))
            // history.push('/startup/dashboard');
        }
    };


    //@ts-ignore
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setForm({ ...form, [e.target.name]: e.target.value });

    //@ts-ignore
    const handleImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.name == "upload") {
            //@ts-ignore
            const file = e.target.files[0];
            const base64 = await convertBase64(file);
            //@ts-ignore
            setForm({ ...form, profilePic: base64 });
        }
        else if (e.type == "click") {
            //@ts-ignore
            setForm({ ...form, profilePic: '' });
        }
        console.log(e);
        console.log(form);
    };

    const convertBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
                resolve(fileReader.result);
            };

            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };
    const switchMode = () => {
        setIsSignup((prevIsSignup) => !prevIsSignup);
        setShowPassword(false);
    };



    return (
        <Container maxWidth="lg">
            <Paper className={classes.paper} elevation={3}>
                {signupStep === 0 && (<InfoSetup
                    form={form}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    switchMode={switchMode}
                    setNext={setNext} />)}
                {signupStep === 1 && (<IconSetup
                    form={form}
                    handleSubmit={handleSubmit}
                    handleImage={handleImage}
                    switchMode={switchMode}
                    setSignupStep={setSignupStep}
                    setNext={setNext} />)}
                {signupStep === 2 && (<PasswordSetup
                    form={form}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleShowPassword={handleShowPassword}
                    handleShowRepeatPassword={handleShowRepeatPassword}
                    switchMode={switchMode}
                    setSignupStep={setSignupStep}
                    setNext={setNext}
                    showPassword={showPassword}
                    showRepeatPassword={showRepeatPassword} />)}

                <PopupNotice setOpen={setOpen} open={open} message={message} buttonLink="/startup/dashboard" buttonText="ホームページヘ" />
            </Paper>
            <GoToTop />
        </Container>
    )
}

export default Signup;